import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DynamicLoaderService {

  constructor() { }


  loadCSS(styleName: string): void {
    const head = document.getElementsByTagName('head')[0];
    const style = document.createElement('link');

    style.rel = 'stylesheet';
    style.href = `${styleName}`;

    head.appendChild(style);
  }

  removeCSS(styleName: string): void {
    const links = document.getElementsByTagName('link');

    [].forEach.call(links, (link) => {
      if (link.href.endsWith(styleName)) {
        link.remove();
      }
    });
  }

  loadJS(jsName: string): void {
    const body = document.getElementsByTagName('body')[0];
    const script = document.createElement('script');

    script.type = 'text/javascript';
    script.src = `${jsName}`;

    body.appendChild(script);
  }
}
